module.exports = __webpack_public_path__ + "static/media/DevMap@64x64.e65c12fa.png";